import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentEnumValueType on EnumValueType {
    entries {
      id
      name
      description
    }
    isMultiselect
  }
`
export const TRANSFORMER = graphql.transformers.OUT.instance<
  graphql.schema.FragmentEnumValueTypeFragment,
  typeof ents.core.common.value.types.Enum
>(
  ents.core.common.value.types.Enum,
  graphql.transformers.OUT.object<
    graphql.schema.FragmentEnumValueTypeFragment,
    ents.core.common.value.types.Enum.constructor.Params
  >({
    // TODO:
    entries: { usingFullInput: graphql.transformers.OUT.always([]) },
    isMultiselect: transformers.PASS_THROUGH,
  }),
)
